import React from "react";

const Terms = () => {
  return (
    <div className="terms-class">
      <h1>Terms and Conditions</h1>
      <p>
        <strong>1. Acceptance of Terms</strong>
      </p>
      <p>
        By accessing or using MuseMatch, you agree to comply with and be bound
        by these Terms and Conditions. If you do not agree with any part of
        these terms, you must not use our service.
      </p>

      <p>
        <strong>2. Use of Content</strong>
      </p>
      <p>
        <strong>2.1. Artistic Expression</strong>
      </p>
      <p>
        MuseMatch celebrates artistic expression. However, content that includes
        nudity or harsh language is permitted only if it is used in a legitimate
        artistic context.
      </p>

      <p>
        <strong>2.2. Prohibited Content</strong>
      </p>
      <p>
        Content that includes nudity or harsh language without an artistic
        context is strictly prohibited. Additionally, any content that is deemed
        offensive, inappropriate, or violates any laws or regulations is not
        allowed.
      </p>

      <p>
        <strong>3. User Responsibilities</strong>
      </p>
      <p>
        Users are responsible for ensuring that their content adheres to these
        guidelines. Any content that violates these rules may result in the
        termination of the user's account.
      </p>

      <p>
        <strong>4. Termination of Accounts</strong>
      </p>
      <p>
        MuseMatch reserves the right to terminate any account that violates
        these Terms and Conditions. This includes, but is not limited to,
        posting prohibited content as described in section 2.
      </p>

      <p>
        <strong>5. Intellectual Property</strong>
      </p>
      <p>
        All content on MuseMatch, unless otherwise stated, is the property of
        MuseMatch or its users. Unauthorized use of any content is prohibited.
      </p>

      <p>
        <strong>6. Governing Law</strong>
      </p>
      <p>
        These Terms and Conditions are governed by and construed in accordance
        with the laws of New York. Any disputes arising from these terms will be
        subject to the exclusive jurisdiction of the courts in New York.
      </p>

      <p>
        <strong>7. Protection of Personal and Payment Information</strong>
      </p>
      <p>
        MuseMatch is committed to safeguarding your personal and payment
        information. All credit card details, billing addresses, and shipping
        addresses provided by users are encrypted and stored securely. We employ
        industry-standard measures to ensure that your personal and financial
        information remains protected.
      </p>
      <p>
        However, MuseMatch is not liable for unauthorized access to this data if
        reasonable security measures are breached. By using our service, you
        acknowledge and agree to the handling of your personal information as
        described in our Privacy Policy.
      </p>

      <p>
        <strong>8. Changes to Terms</strong>
      </p>
      <p>
        MuseMatch reserves the right to modify these Terms and Conditions at any
        time. Changes will be effective immediately upon posting. Continued use
        of the service after changes have been made constitutes acceptance of
        the new terms.
      </p>

      <p>
        By accepting these you agree to the Terms and Conditions and Return
        Policy of MuseMatch.
      </p>
    </div>
  );
};

export default Terms;
